<template>
  <div v-if="show" class="subscribe-modal-overlay">
    <div class="subscribe-modal-card">
      <button class="modal-close-btn" @click="closeModal" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#1D2941"/>
          <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div class="modal-header">
        <div class="register-badge">Register Now</div>
        
        <h2 class="modal-title">
          <span class="text-dark">Start For Just</span>
          <span class="text-gradient">
            {{ plans && plans[selectedPlanIndex] && plans[selectedPlanIndex].offerPriceText ? plans[selectedPlanIndex].offerPriceText : '$0.95' }}
          </span>
        </h2>
        
        <p class="modal-subtitle">Offer for 1st month</p>
        
      </div>

      <div class="modal-plans">
        <div 
          v-for="(plan, idx) in plans" 
          :key="plan._id || idx" 
          class="plan-card"
          :class="{ 'selected': idx === selectedPlanIndex }"
          @click="selectPlan(idx)"
        >
          <div class="plan-card-header">
            <span class="plan-name">{{ plan.plan_name || 'Plan' }}</span>
            <span v-if="idx === selectedPlanIndex" class="plan-check">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="8" fill="#F84109"/>
                <path d="M4.5 8L7 10.5L11.5 5.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
          <div class="plan-prices">
            <span class="plan-offer-price">{{ plan.offerPriceText || '$0.00' }}</span>
            <span v-if="plan.originalPriceText" class="plan-original-price">{{ plan.originalPriceText }} / mo</span>
          </div>
        </div>
      </div>

      <form class="modal-form" @submit.prevent="handleSubscribe(selectedPlanIndex)" novalidate>
        <div class="email-input-wrapper" :class="{ 'input-highlight': emailInputHighlight }">
          <div style="position: relative; flex: 1; display: flex; min-width: 0;">
            <input
              :value="email"
              @input="updateEmail"
              type="email"
              placeholder="Enter your Email"
              class="email-input"
              autocomplete="email"
              required
              ref="emailInput"
            />
            <div v-if="emailError" class="error-tooltip">
              {{ emailError }}
            </div>
          </div>
          <button class="start-monitoring-btn" type="submit">
            Start Monitoring
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscribeModal',
  data() {
    return {
      emailError: ''
    };
  },
  props: {
    show: { type: Boolean, default: false },
    plans: { type: Array, default: () => [] },
    selectedPlanIndex: { type: Number, default: 0 },
    formattedOfferEndsIn: { type: Object, required: true },
    email: { type: String, default: '' },
    emailInputHighlight: { type: Boolean, default: false },
  },
  methods: {
    updateEmail(event) {
      this.emailError = '';
      this.$emit('update:email', event.target.value);
    },
    selectPlan(idx) {
      this.$emit('update:selectedPlanIndex', idx);
    },
    handleSubscribe(idx) {
      const emailRegex = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.email || !emailRegex.test(this.email)) {
        this.emailError = 'Please enter a valid email address';
        return;
      }
      this.$emit('subscribe', idx);
    },
    closeModal() {
      this.$emit('close');
    }
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400;0,500;0,600;1,500&family=Mulish:wght@600;700&display=swap');

.subscribe-modal-overlay {
  position: fixed;
  z-index: 2000;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(30, 34, 54, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.subscribe-modal-card {
  background: #FFF;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
  width: 100%;
  max-width: 650px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 25px;
  position: relative;
  background-color: #FFFFFF;
  background-image: 
    radial-gradient(circle at 10% 10%, #FFE9DE 0%, transparent 40%),
    radial-gradient(circle at 50% 100%, #FFE9DE 0%, transparent 40%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
}

.modal-close-btn:hover {
  opacity: 0.8;
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
}

.register-badge {
  display: inline-flex;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 60px;
  border: 1px solid rgba(29, 41, 65, 0.10);
  background: radial-gradient(124.43% 90.61% at 50.09% 100%, rgba(248, 65, 9, 0.05) 34.39%, rgba(255, 255, 255, 0.00) 100%);
  color: #1D2941;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 24px;
}

.modal-title {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
  margin-top: 0;
}

.text-dark {
  color: var(--Dark-blue, #1D2941);
  text-align: center;
  font-family: 'Mulish', sans-serif;
  font-size: 38px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -1.5px;
}

.text-gradient {
  font-family: 'Mulish', sans-serif;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 58px;
  letter-spacing: -2px;
  background: linear-gradient(95deg, var(--Accent---Orange, #F84109) 64.99%, var(--White, #F2F5F7) 111.97%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.modal-subtitle {
  color: var(--Text, rgba(0, 0, 0, 0.80));
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
  line-height: 24px;
  margin-top: 0;
  margin-bottom: 24px;
}


.modal-plans {
  display: flex;
  gap: 20px;
  justify-content: center;
  width: 100%;
  margin-bottom: 50px;
  flex-wrap: wrap;
}

.plan-card {
  display: flex;
  flex: 1;
  min-width: 0;
  height: 93px;
  padding: 15px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  border-radius: 16px;
  border: 1px solid rgba(29, 41, 65, 0.10);
  background: radial-gradient(124.43% 90.61% at 50.09% 100%, rgba(248, 65, 9, 0.05) 34.39%, rgba(255, 255, 255, 0.00) 100%);
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.plan-card.selected {
  border: 1px solid var(--Accent---Orange, #F84109);
  background: radial-gradient(121.09% 90.61% at 50.09% 100%, rgba(248, 65, 9, 0.15) 34.39%, rgba(255, 255, 255, 0.00) 100%);
  box-shadow: 0 10px 20px 0 rgba(248, 65, 9, 0.20);
}

.plan-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.plan-name {
  color: #1D2941;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.plan-prices {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.plan-offer-price {
  color: #1D2941;
  font-family: 'Mulish', sans-serif;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.plan-card.selected .plan-offer-price {
  background: linear-gradient(95deg, var(--Accent---Orange, #F84109) 64.99%, var(--White, #F2F5F7) 111.97%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.plan-original-price {
  color: rgba(29, 41, 65, 0.40);
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-decoration: line-through;
}

.modal-form {
  width: 100%;
  display: flex;
  justify-content: center;
}

.email-input-wrapper {
  display: flex;
  width: 100%;
  height: 54px;
  padding: 5px 5px 5px 20px;
  justify-content: space-between;
  align-items: center;
  border-radius: 44px;
  border: 1px solid rgba(248, 65, 9, 0.20);
  background: #FFF;
  transition: box-shadow 0.3s;
  box-sizing: border-box;
}

.email-input-wrapper.input-highlight {
  box-shadow: 0 0 0 2px rgba(248, 65, 9, 0.40);
}

.email-input {
  border: none;
  outline: none;
  flex: 1;
  color: #1D2941;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  background: transparent;
  min-width: 0;
}

.email-input::placeholder {
  color: rgba(29, 41, 65, 0.50);
}

.start-monitoring-btn {
  display: flex;
  padding: 0 28px;
  justify-content: center;
  align-items: center;
  border-radius: 44px;
  background: linear-gradient(180deg, #FF6633 0%, #F84109 100%);
  color: #FFF;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  height: 100%;
  transition: transform 0.2s, background 0.3s;
  box-shadow: inset 0 2px 4px rgba(255,255,255,0.2);
}

.start-monitoring-btn:hover {
  transform: translateY(-1px);
  background: linear-gradient(180deg, #FF7744 0%, #D53000 100%);
}

.error-tooltip {
  position: absolute;
  bottom: 100%;
  left: 10px;
  margin-bottom: 8px;
  background-color: #F84109;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-family: 'Inter', sans-serif;
  white-space: nowrap;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  z-index: 10;
  animation: fadeIn 0.2s ease-out;
}
.error-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 20px;
  border-width: 5px;
  border-style: solid;
  border-color: #F84109 transparent transparent transparent;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 768px) {
  .subscribe-modal-card {
    padding: 30px 20px;
  }
  .modal-title {
    flex-direction: column;
    gap: 0;
  }
  .text-dark {
    font-size: 28px;
    line-height: 36px;
  }
  .text-gradient {
    font-size: 36px;
    line-height: 44px;
  }
  .modal-plans {
    flex-direction: column;
    align-items: center;
  }
  .plan-card {
    width: 100%;
    max-width: 300px;
  }
  .email-input-wrapper {
    width: 100%;
    flex-direction: column;
    height: auto;
    padding: 6px;
    border-radius: 20px;
    gap: 10px;
    background: transparent;
    border: none;
  }
  .email-input {
    width: 100%;
    padding: 16px 20px;
    background: #FFF;
    border: 1px solid rgba(248, 65, 9, 0.20);
    border-radius: 44px;
  }
  .start-monitoring-btn {
    width: 100%;
    padding: 16px;
    border-radius: 44px;
  }
}

/* Global Font Override */
* {
  font-family: 'Mulish', sans-serif !important;
}
</style>